module.exports = __webpack_public_path__ + "img/banner-1-m.3da3d25c.jpg";